import React from 'react';
import LevelingRankPicker from './LevelingRankPicker';

export default class Leveling1To60Hardcore extends React.PureComponent {
  static minValue = 1;
  static maxValue = 60;

  static describeRank = rank => rank.toString();
  static getDefaultValue = () => [1, 30];

  static marks = {
    1: '1',
    10: '10',
    20: '20',
    30: '30',
    40: '40',
    50: '50',
    60: '60',
  };

  render() {
    const { ...rest } = this.props;

    return (
      <LevelingRankPicker
        {...rest}
        min={Leveling1To60Hardcore.minValue}
        max={Leveling1To60Hardcore.maxValue}
        marks={Leveling1To60Hardcore.marks}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/levelingRankPicker/Leveling1To60Hardcore.js